import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { fn0, fn0nZ, fn1nZ, fn2, fn2nZ } from '../../core/formatter/formatNumber';
import { getEmissionsFaktor } from '../../main/functions/getEmmissionsFaktor';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import { KennzahlenInfo } from './elements/KennzahlenInfo';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungStromNeuProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortTid: number;
    standortName: string;
    routing: any;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungStromNeuState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungStromNeu extends React.Component<DatenauswertungStromNeuProps, DatenauswertungStromNeuState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private devFeaturesMap: any = config.devFeaturesMap || {};
    private disableKosten: boolean;
    private entities: any[] = [
        { titel: i18n('Strom', 'sys'), entity: IDs.ENT_ENERGIEDATEN_STROM },
        { titel: i18n('Eigenstrom', 'sys'), entity: IDs.ENT_ENERGIEDATEN_EIGENSTROM }
    ];
    private modul: string;

    componentDidMount(): void {
        const data: any = this.props.data || {};
        this.modul = data.MODUL_SELECTED || null;
        this.disableKosten = disableKosten(data);
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr'
            ).getData()
        });
    }

    getValues(): any {
        const data: any = this.props.data || {};
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[this.props.standortTid]
            || data[IDs.KENNZIFFERN_BERECHNET] || {};

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            // let faktor_strom_co2 = getEmissionsFaktor(this.props.data, '', jahr, 'strom_mix');
            // console.log('Strom Aus 1: ', jahr, faktor_strom_co2);
            if (!kennzahlen[jahr]) {
                continue;
            }
            const faktor_strom_co2 = kennzahlen[jahr].faktor_strom_co2_calc;
            // console.log('Strom Aus 2: ', jahr, faktor_strom_co2);
            // console.log('Strom: ', kennzahlen[jahr]);
            const strom_verbrauch_fremdbezug = kennzahlen[jahr] && kennzahlen[jahr].strom_verbrauch_fremdbezug
                ? kennzahlen[jahr].strom_verbrauch_fremdbezug
                : null;
            const strom_kosten_gesamt = kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt
                ? kennzahlen[jahr].strom_kosten_gesamt
                : null;
            let co2_strom = kennzahlen[jahr].co2_strom_precalc;
            co2_strom = Math.round(co2_strom * 100) / 100;
            const spitzenlast_strom = kennzahlen[jahr] && kennzahlen[jahr].spitzenlast_strom
                ? kennzahlen[jahr].spitzenlast_strom
                : 0;
            const preis = strom_verbrauch_fremdbezug > 0 ? strom_kosten_gesamt / strom_verbrauch_fremdbezug : 0;

            // if (!co2_strom || co2_strom === 0) {
            //    faktor_strom_co2 = 0;
            // }
            const eigenstrom_autarkiegrad = kennzahlen[jahr].eigenstrom_autarkiegrad;
            const eigenstrom_verbrauch_kwh = kennzahlen[jahr].eigenstrom_verbrauch_kwh;
            const eigenstrom_verbrauch_quote = kennzahlen[jahr].eigenstrom_verbrauch_quote;
            const eigenstrom_einspeisung_kwh = kennzahlen[jahr].eigenstrom_einspeisung_kwh;
            const eigenstrom_einspeisung_verguetung = kennzahlen[jahr].eigenstrom_einspeisung_verguetung;
            const strom_verbrauch_gesamt_und_eigen = (+strom_verbrauch_fremdbezug || 0) + (+eigenstrom_verbrauch_kwh || 0);
            const renderInfoCo2 = this.renderKennzahlenInfo(strom_verbrauch_fremdbezug > 0 ? fn2(co2_strom) : '', jahr, 'strom_fremdbezug', 'co2');
            const renderInfoEigenverbrauch = this.renderKennzahlenInfo(fn0nZ(eigenstrom_verbrauch_kwh), jahr, 'eigenstrom', 'verbrauch');
            const renderInfoEinspeiseverguetung = this.renderKennzahlenInfo(fn2nZ(eigenstrom_einspeisung_verguetung), jahr, 'eigenstrom', 'einspeiseverguetung');
            const renderInfoEinspeisung = this.renderKennzahlenInfo(fn0nZ(eigenstrom_einspeisung_kwh), jahr, 'eigenstrom', 'einspeisung');
            const renderInfoKosten = this.renderKennzahlenInfo(fn2nZ(strom_kosten_gesamt), jahr, 'strom_fremdbezug', 'kosten');
            const renderInfoSpitzenlast = this.renderKennzahlenInfo(fn1nZ(spitzenlast_strom), jahr, 'strom', 'spitzenlast');
            const renderInfoVerbrauch = this.renderKennzahlenInfo(fn0nZ(strom_verbrauch_fremdbezug), jahr, 'strom_fremdbezug', 'verbrauch');
            const renderInfoVerbrauchGesamt = this.renderKennzahlenInfo(fn0nZ(strom_verbrauch_gesamt_und_eigen), jahr, 'strom_gesamt', 'verbrauch');
            const row: any[] = [
                jahr,
                renderInfoVerbrauch/*fn0nZ(strom_verbrauch_fremdbezug)*/, renderInfoVerbrauchGesamt/*fn0nZ(strom_verbrauch_gesamt_und_eigen)*/, renderInfoKosten/*fn2nZ(strom_kosten_gesamt)*/, fn2nZ(preis),
                renderInfoSpitzenlast/*fn1nZ(spitzenlast_strom)*/, strom_verbrauch_fremdbezug > 0 ? fn0(faktor_strom_co2 * 1000000) : '',
                renderInfoCo2/*strom_verbrauch_fremdbezug > 0 ? fn2(co2_strom) : ''*/,
                renderInfoEigenverbrauch/*fn0nZ(eigenstrom_verbrauch_kwh)*/, renderInfoEinspeisung/*fn0nZ(eigenstrom_einspeisung_kwh)*/, renderInfoEinspeiseverguetung/*fn2nZ(eigenstrom_einspeisung_verguetung)*/,
                fn2nZ(eigenstrom_verbrauch_quote), fn2nZ(eigenstrom_autarkiegrad)
            ];
            if (this.modul === 'cfm') {
                row.splice(5, 1); // Spitzenlast
            // } else {
            //     row.splice(11, 2); // Eigenstrom Eigenverbrauchsquote; Eigenstrom Autarkiegrad
            }
            if (this.disableKosten) {
                row.splice(3, 2); // Kosten Fremdbezug [€ (netto)]; Kosten Fremdbezug [€/kWh]
            }
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = {
                jahr, verbrauch: +(strom_verbrauch_gesamt_und_eigen || 0).toFixed(),
                ...(!this.disableKosten && { kosten: strom_kosten_gesamt })
            };
            const d2 = { jahr, emission: co2_strom };
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            data={this.props.data}
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): void => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (strom_verbrauch_gesamt_und_eigen || (!this.disableKosten && strom_kosten_gesamt)) {
                    diag1.push(d1);
                }
                if (strom_verbrauch_fremdbezug !== null) {
                    diag2.push(d2);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        // console.log('D2: ', diag2);
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#87bd51', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        const widthCols: number[] = [
            0.75,   // [0] Jahr
            1,      // [1] Fremdbezug kWh
            1,      // [2] Gesamtverbrauch kWh
            0.75,   // [3] Kosten € (netto)
            0.75,   // [4] Kosten €/kWh
            0.75,   // [5] Spitzenlast kW
            0.75,   // [6] CO₂ gCO₂/kWh
            0.75,   // [7] CO₂ t
            0.75,   // [8] Eigenverbrauch kWh
            0.75,   // [9] Einspeisung kWh
            0.75,   // [10] Vergütung € (netto)
            0.75,   // [11] Eigenverbrauchsquote %
            0.75    // [12] Autarkiegrad %
        ];
        const calcWidth: number[] = [...widthCols];
        if (this.modul === 'cfm') {
            calcWidth.splice(5, 1); // Spitzenlast
        // } else {
        //     calcWidth.splice(11, 2); // Eigenstrom Eigenverbrauchsquote; Eigenstrom Autarkiegrad
        }
        if (this.disableKosten) {
            calcWidth.splice(3, 2); // Kosten Fremdbezug [€ (netto)]; Kosten Fremdbezug [€/kWh]
        }
        const baseWidth = 100 / calcWidth.reduce((sum: number, value: number) => sum + value, 0); // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const eigenstrom_header = this.renderEigenstromHeader();
        const customStyle = eigenstrom_header === i18n('Keine erneuerbaren Energien vorhanden', 'sys')
            ? { fontWeight: 'normal', fontStyle: 'italic' } : {};
        // console.log('CSL:', customStyle);
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung Strom', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Strom', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'strom' },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth * widthCols[0]}%`
                    },
                    {
                        label: i18n('Stromverbrauch', 'sys'),
                        width: `${baseWidth * (widthCols[1] + widthCols[2])}%`,
                        columns: [
                            { label: i18n('Fremdbezug', 'sys'), label2: 'kWh', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Gesamtverbrauch', 'sys'), label2: 'kWh', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: `${i18n('Stromverbrauch{{lb}}Kosten', 'sys').replace('{{lb}}', '\n')} (${i18n('Fremdbezug', 'sys')})`,
                        width: `${baseWidth * (widthCols[3] + widthCols[4])}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})`, customStyleLabel2: { borderTop: '0pt solid #fff' } },
                            { label2: '€/kWh', customStyleLabel2: { borderTop: '0pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Spitzenlast', 'sys'),
                        width: `${baseWidth * widthCols[5]}%`,
                        columns: [
                            { label2: 'kW' }
                        ]
                    },
                    {
                        label: `${i18n('Verbrauchsbedingte{{lb}}CO₂-Emissionen', 'sys').replace('{{lb}}', '\n')}`,
                        width: `${baseWidth * (widthCols[6] + widthCols[7])}%`,
                        columns: [
                            { label2: 'gCO₂/kWh' },
                            { label2: 't' }
                        ]
                    },
                    {
                        label: <>{eigenstrom_header}</>,
                        customStyle,
                        width: `${baseWidth * (widthCols[8] + widthCols[9] + widthCols[10] + widthCols[11] + widthCols[12])}%`,
                        // width: `${baseWidth * (widthCols[8] + widthCols[9] + widthCols[10]
                        //     + (this.modul === 'cfm' ? widthCols[11] + widthCols[12] : 0))}%`,
                        columns: [
                            { label: i18n('Eigenverbrauch', 'sys'), label2: 'kWh', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Einspeisung', 'sys'), label2: 'kWh', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Vergütung', 'sys'), label2: `€ (${i18n('netto', 'sys')})`, customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Eigenverbrauchsquote', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Autarkiegrad', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , , , 'row_field_dark', , 'row_field_dark'],
            rows_width: widthCols.map((width: number) => baseWidth * width),
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            diagrams: [
                {
                    title: `${i18n('Stromverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Stromkosten', 'sys')}` : ''}`,
                    titlePdf: `${i18n('Stromverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Stromkosten', 'sys')}` : ''}`,
                    legend: [`${i18n('Stromverbrauch', 'sys')} [kWh]`, ...(!this.disableKosten ? [`${i18n('Stromkosten', 'sys')} [€]`] : [])],
                    unit: ['kWh', ...(!this.disableKosten ? ['€'] : [])],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['verbrauch', ...(!this.disableKosten ? ['kosten'] : [])],
                    data: values.diag1,
                    tickPeriod: [50, ...(!this.disableKosten ? [50] : [])],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' }
                },
                {
                    title: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                    titlePdf: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                    legend: [`${i18n('CO₂-Emissionen', 'sys')} [t]`],
                    unit: ['t'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['emission'],
                    data: values.diag2,
                    tickPeriod: [50, 50],
                    singleYAxis: true,
                    lineColor,
                    containerSize: { width: '90%' }
                }
            ]
        };
        if (this.modul === 'cfm') {
            config.header.blocks.splice(3, 1); // Spitzenlast
        // } else {
        //     config.header.blocks[5].columns.splice(3, 2); // Eigenstrom Eigenverbrauchsquote; Eigenstrom Autarkiegrad
        }
        if (this.disableKosten) {
            config.header.blocks.splice(2, 1); // Stromverbrauch (Kosten Fremdbezug)
            config.row_classes.splice(3, 2); // Stromverbrauch (Kosten Fremdbezug)
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_strom'
                type='info'
                editBar
                useTheme
            />
        );
        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}
        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='strom'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEigenstromHeader(): JSX.Element[] {
        const values = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM];
        const typen = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN];
        const typen_filtered = typen.filter((item: any) => values.some((aw: any) =>
            item.typ === 'S' && aw.anlagen_eigenstrom_typ_tid_orig === item.tid
        ));

        if (!typen_filtered || typen_filtered.length === 0) {
            return i18n('Keine erneuerbaren Energien vorhanden', 'sys');
        }
        const arr = typen_filtered.map((item: any, idx: number) =>
            <React.Fragment key={`typ-${idx}`}>
                &nbsp;{i18n(item.name, 'sys')}&nbsp;{((idx + 1) < typen_filtered.length ? '/' : '')}
            </React.Fragment>
        );
        // console.log('Typen', typen, typen_filtered, arr);
        return [<React.Fragment key={`typ-`}>{`${i18n('Eigenstrom', 'sys')}\n`}</React.Fragment>, ...arr];
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = this.entities.map((item: any) => item.entity);
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderKennzahlenInfo(value: string, jahr: number, key: string, field: string): JSX.Element | string {
        // return !!this.devFeaturesMap.N131_KENNZAHLEN_BERECHNUNG && (this.apiService.isAdmin() || this.apiService.isBerater())
        return true
            ? <KennzahlenInfo
                data={this.props.data}
                data-text={value}
                id={`${key}_${field}_${jahr}`}
                key={`${key}_${field}_${jahr}`}
                keyValue={`${key}_${field}`}
                jahr={jahr}
                standort={this.props.standortTid || 'ALL'}
            />
            : value;
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasStrom);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
